"use strict";

var ROLES = require('../core/roles.constant');
module.exports = [ROLES.SAFETY_COORDINATOR];